import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  UploadCarouselVideoRequest,
  UploadCarouselVideoResponse,
} from "@punchup/data/models";
import { uploadCarouselVideo, CAROUSEL_QUERY_KEY } from "./api";

interface UploadCarouselVideoParams {
  venuePageId: string;
  data: UploadCarouselVideoRequest;
}

/**
 * Hook to upload a new video to the carousel
 */
export function useUploadCarouselVideo(): UseMutationResult<
  UploadCarouselVideoResponse,
  Error,
  UploadCarouselVideoParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ venuePageId, data }: UploadCarouselVideoParams) =>
      uploadCarouselVideo(venuePageId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [CAROUSEL_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
